const WhatsAppButton = () => {
  const handleClick = () => {
    const phone = "201100235470";
    const message = "مرحبا أحتاج مساعدة";
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    const newWindow = window.open("", "_blank");
    if (newWindow) newWindow.location.href = url;
  };

  return (
    <button
      onClick={handleClick}
      aria-label="تواصل معنا عبر واتساب"
      title="تواصل معنا عبر واتساب"
      className="fixed bottom-6 left-6 z-50 flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full shadow-lg transition-transform hover:scale-110 active:scale-95 animate-pulse hover:animate-none cursor-pointer border-none outline-none"
      style={{ backgroundColor: "#25D366" }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        className="w-7 h-7 md:w-8 md:h-8 fill-white"
      >
        <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.958A15.9 15.9 0 0016.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.318 22.614c-.396 1.116-1.956 2.042-3.216 2.312-.864.182-1.992.328-5.792-1.246-4.862-2.014-7.988-6.94-8.23-7.262-.232-.32-1.946-2.594-1.946-4.948 0-2.354 1.232-3.512 1.67-3.992.436-.48.952-.6 1.27-.6.316 0 .632.002.908.016.292.014.684-.11 1.07.816.396.952 1.346 3.286 1.466 3.526.118.24.196.52.038.838-.158.32-.238.518-.476.8-.236.28-.498.626-.712.84-.236.238-.484.496-.208.972.278.476 1.234 2.034 2.65 3.296 1.82 1.622 3.354 2.126 3.83 2.364.476.238.754.198 1.03-.118.278-.318 1.19-1.386 1.506-1.862.318-.476.634-.396 1.07-.238.436.158 2.77 1.306 3.246 1.544.476.238.794.358.912.554.118.198.118 1.148-.278 2.264z" />
      </svg>
    </button>
  );
};

export default WhatsAppButton;
